import React, { useEffect, useState } from "react";
import { ApiURL } from "../../../../../services/apiConstants";
import { post } from "../../../../../services/services";
import SisLoader from "../../../../../widgets/loader";
import LPGCargoCompressorDetailsTable from "../../components/CargoCraneCom/LpgCargoCompressorRow";

function StaffLPGCargoCompressor({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchLPGCargoCompressorList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_cargo_machinery_lpg_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.lpg_cargo_parameters_data || []);
      }
    } catch (error) {
      console.error("Error fetching LPG Cargo Compressor list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchLPGCargoCompressorList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>LPG Cargo Compressor Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <LPGCargoCompressorDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffLPGCargoCompressor;
// import
